/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 */

/**
 * Split a brand name into two halves for the two-tone wordmark.
 * "SanitàNexus" → ["Sanità", "Nexus"] (mid-split), "Clinica Rossi" → ["Clinica", "Rossi"].
 */
export const splitBrandName = (name) => {
  const words = (name || '').split(/\s+/).filter(Boolean);
  if (words.length > 1) return [words.slice(0, -1).join(' '), words[words.length - 1]];
  const mid = Math.ceil((name || '').length / 2);
  return [(name || '').slice(0, mid), (name || '').slice(mid)];
};
